<template>
  <div>
    <div class="row col-12 q-my-lg">
      <AdicionarEncerramento
        :unidadeId="unidade.id"
        @closing="buscarListaEncerramento"
      />
    </div>
    <span
      class="row col-12 text-brand-5 text-weight-bold q-ml-md q-mt-xl q-mb-md titulo-table"
      >Lista de Perguntas</span
    >
    <div class="col-12">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        :rows="listaEncerramento"
        :columns="columns"
        row-key="encerramentoId"
        :rows-per-page-options="[0]"
        :grid="$q.screen.lt.sm"
        hide-bottom
        dense
        :loading="loading"
        flat
        color="primary"
        class="tabela-tamanho-fixo"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div
              class="row card text-grid-table text-brand-5 text-weight-bold q-pa-xs"
            >
              <div class="row col-12 items-center justify-between">
                <span class="col-9">{{ props.row.pergunta }}</span>
                <q-btn
                  icon="remove_circle_outline"
                  color="red"
                  flat
                  size="md"
                  @click="removerPergunta(props.row.encerramentoId)"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-pergunta="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            {{ props.row.pergunta }}
          </q-td>
        </template>
        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              color="white"
              text-color="red"
              flat
              label="Remover"
              no-caps
              icon="remove_circle_outline"
              @click="removerPergunta(props.row.encerramentoId)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

import AdicionarEncerramento from "./AdicionarEncerramento.vue";

export default {
  components: {
    AdicionarEncerramento,
  },
  setup() {
    const columns = [
      {
        name: "pergunta",
        required: true,
        label: "Pergunta",
        align: "left",
        field: (row) => row.pergunta,
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
        field: "encerramentoId",
        sortable: false,
      },
    ];
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();
    const listaEncerramento = ref();
    const unidade = ref("");
    let loading = ref(false);

    const buscarListaEncerramento = async () => {
      loading.value = true;
      const resposta = await store.dispatch("pdt/listarEncerramento", {
        unidadeId: unidade.value.id,
      });

      listaEncerramento.value = resposta.data.resultado.dados;
      loading.value = false;
    };

    const removerPergunta = async (encerramentoId) => {
      await store.dispatch("pdt/removerEncerramento", {
        unidadeId: unidade.value.id,
        encerramentoId,
      });
      quasar.notify({
        message: "Pergunta removida",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
          },
        ],
      });
      buscarListaEncerramento();
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      buscarListaEncerramento();
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        getUnidade();
      }
    );

    const voltar = () => {
      router.push({ name: "pdt-unidade" });
    };

    onMounted(getUnidade);

    return {
      columns,
      removerPergunta,
      listaEncerramento,
      unidade,
      buscarListaEncerramento,
      voltar,
      loading,
    };
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}
.titulo-table {
  font-size: 18px;
}
@media (max-width: 600px) {
  .titulo-table {
    font-size: 15px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 10px 0px 18px 0px;
  }
  .card {
    border: 1px solid #707070;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
